import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import Session from '../../utils/session.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import AngularStateHelperService from '../../services/angular-state-helper.service';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'footer',
	templateUrl: './footer.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class FooterComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private session: Session = inject(Session);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Session.LOGIN, (event, data) => {
					var currentSession = this.session.getSession();
					var origin: any = (currentSession && currentSession.user && currentSession.user.origin)
						? currentSession.user.origin
						: 'minudoc.ee';
					this.vm.origin = origin;
					this.vm.user = this.session.getSession().user;

					var location: any = window.location.href;
					if (location.includes('eelvisiit')) {
						this.vm.previsitLocation = true;
					}
					this.constructLinks(origin);

					if (origin == 'siffi.com') {
						this.vm.contactEmail = 'contact@siffi.com';
					} else if (origin == 'minudoc.fi') {
						this.vm.contactEmail = 'info@minudoc.fi';
					} else {
						this.vm.contactEmail = this.vm.previsitLocation ? 'info@perearstitugi.ee' : 'info@minudoc.ee';
					}

					this.vm.initialized = true;
				})
		);
		
		this.vm.reload = this.reload;
		this.vm.reloadToPrevisit = this.reloadToPrevisit;
		this.vm.hideFooter = this.hideFooter;
		this.vm.getGlobalProperty = this.getGlobalProperty;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}

	getGlobalProperty(name) {
		return this.angularStateHelperService.getGlobalProperty(name);
	}
	
	hideFooter() {
		if (this.vm.previsitLocation) {
			if (this.angularRoutingHelperService.getCurrentPath() === 'av-test') {
				return true;
			}
			return false;
		} else {
			var currentRoute: any = this.angularRoutingHelperService.getCurrentRoute();
			if (currentRoute && currentRoute.originalPath) {
				currentRoute = currentRoute.originalPath;
			}
			if (this.vm.currentRoute === currentRoute) {
				return this.vm.currentRouteFooterVisible;
			} else {
				var newRouteFooterVisible: any = this.angularRoutingHelperService.getCurrentRouteConfigFor('hideFooter');
				this.vm.currentRouteFooterVisible = newRouteFooterVisible == null ? false : true;
				this.vm.currentRoute = currentRoute;
				return this.vm.currentRouteFooterVisible;
			}
		}
	}
	
	constructLinks(origin) {
		var links: Array<any> = [];
		if (origin == 'siffi.com') {
			var locale: any = (this.vm.user && this.vm.user.deviceLanguage) || 'en_GB';
			if (!this.vm.user.previsitUser) {
				links.push({
					label: this.angularFilterHelperService.translate('Sidebar.Menu.About'),
					link: this.config.getSiffiPublicWebUrl(locale, '/about-us'),
				});
			}
			links.push({
				label: this.angularFilterHelperService.translate('Sidebar.Menu.ToS'),
				link: this.config.getSiffiPublicWebUrl(locale, '/terms-of-service')
			});
			links.push({
				label: this.angularFilterHelperService.translate('Sidebar.Menu.PP'),
				link: this.config.getSiffiPublicWebUrl(locale, '/privacy-policy')
			});
		} else {
			if (!this.vm.user.previsitUser && !this.vm.previsitLocation) {
				links.push({
					label: this.angularFilterHelperService.translate('Sidebar.Menu.About'),
					link: this.createMinuDocPublicWebUrl({ et_EE: '/meist', en_GB: '/about', fi_FI: '/noin' }),
				});
				links.push({
					label: this.angularFilterHelperService.translate('Sidebar.Menu.Faq'),
					link: this.createMinuDocPublicWebUrl({ et_EE: '/kkk', en_GB: '/faq', fi_FI: '/ukk' }),
				});
			}
			links.push({
				label: this.angularFilterHelperService.translate('Sidebar.Menu.ToS'),
				link: this.createMinuDocPublicWebUrl({ et_EE: '/kasutustingimused', en_GB: '/terms-of-service', fi_FI: '/kayttoehdot' })
			});
			links.push({
				label: this.angularFilterHelperService.translate('Sidebar.Menu.PP'),
				link: this.createMinuDocPublicWebUrl({ et_EE: '/privaatsuspoliis', en_GB: '/privacy-policy', fi_FI: '/tietosuojakaytanto' })
			});
		}
		this.vm.links = links;
	}

	createMinuDocPublicWebUrl(translations?, fallbackLocale?) {
		translations = translations || {};
		fallbackLocale = fallbackLocale || 'en_GB';
		var user: any = this.session.getSession().user;
		var language: any = (user && user.deviceLanguage) || fallbackLocale;
		var path: any = translations[language] || translations[fallbackLocale] || '';
		return this.config.getPublicWebUrl() + path;
	}
	
	reload() {
		if (this.angularRoutingHelperService.getCurrentPath() === '/' || this.angularRoutingHelperService.getCurrentPath() === '') window.location.reload();
	}
	
	reloadToPrevisit(event) {
		if (event && event.preventDefault) {
			event.preventDefault();
		}
		this.angularRoutingHelperService.clearQueryParamsDirty()
		if (this.vm.user
				&& this.vm.user.businessUserType === 'SERVICE_PROVIDER'
				&& this.vm.user.service
				&& this.vm.user.service.preVisitEnabled) {
			this.angularRoutingHelperService.setPath('/pre-visit/record-ticket-for-person');
		} else {
			this.angularRoutingHelperService.setPath('/pre-visit');
		}
	}
	
}
